<template>
    <div>
        <header-nav :cur="3" />
        <!-- 搜索 -->
        <div class="nav">
            <div class="navtab">
                <span class="top">
                    首页&nbsp;>
                    <span class="infor">班级</span>
                </span>
                <div class="newbox">
                    <div>
                        <div class="newtop">班级学习中心</div>
                        <div class="newbot">加入班级，更快速的成长</div>
                    </div>
                    <div class="input">
                        <input placeholder="请输入您想要寻找的课程" type="text" />
                        <div class="select">搜索</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 报名信息 -->
        <div class="navtab infor" v-if="!sub">
            <div class="title">报名信息</div>
            <div class="infomession">
                <!-- 用户信息 -->
                <div class="info-inner">
                    <div>
					     <div class="message">
					         <div class="name"><a style="color:red">*</a>姓名：<input type="text" class="input" v-model="userName"/></div>
					         <div class="name"><a style="color:red">*</a>身份证号：<input type="text" class="input" v-model="userName"/></div>
					         <div class="name"><a style="color:red">*</a>手机号：<input type="text" class="input" v-model="userName"/></div>
							 <div class="name"><a style="color:red">*</a>专业：<input type="text" class="input" v-model="userName"/></div>			 
							 <div class="name"><a style="color:red">*</a>学历：<input type="text" class="input" v-model="userName"/></div>				 
							 <div class="name"><a style="color:red">*</a>职位：<input type="text" class="input" v-model="userName"/></div>
						     <div class="name"><a style="color:red">*</a>证书号：<input type="text" class="input" v-model="userName"/></div>
						     <div class="name"><a style="color:red">*</a>执业证书号：<input type="text" class="input" v-model="userName"/></div>
					         <div class="submit" @click="commitData()">提交申请</div>
					     </div>
					</div>
                  <!--  <div class="subbox">
                        <div class="close" @click="close()">取消</div>
                        <div class="submit" @click="submit(submit)">提交</div>
                    </div> -->
                </div>
            </div>
        </div>
        <!-- 提交成功 -->
        <div class="navtab success" v-if="sub">
            <div class="suc">恭喜您！报名成功</div>
            <img src="../../assets/img/grade/success.svg" alt="" />
            <div class="title" @click="backhome()">
                点击这里，
                <span>返回首页</span>
            </div>
        </div>
        <!-- 提交失败 -->
        <div class="navtab success" v-if="sub">
            <div class="suc">报名失败</div>
            <img src="../../assets/img/grade/false.svg" alt="" />
            <div class="cause">
                <font>*</font>
                这里是失败原因这里是失败原因这里是失败原因这里是失败原因这里是失败原因这里是失败原因这里是失败原因这里是失败原因这里是失败原因这里是失败原因这里是失败原因
            </div>
            <div class="title" @click="backhome()">
                点击这里，
                <span>返回上一级</span>
            </div>
        </div>
        <footer-nav />
    </div>
</template>
<script>
import headerNav from '../../components/HeaderNav.vue';
import footerNav from '../../components/FooterBar';
export default {
    components: {
        headerNav,
        footerNav,
    },
    data() {
        return {
			formData: {
			    field101: undefined,
			    field103: undefined,
			    field102: undefined,
			    field104: undefined,
			    field105: undefined,
			    field106: undefined,
			    field107: undefined,    
			},
            sub: '',
        };
    },
    methods: {
        close() {
            this.$router.back(-1);
        },
        submit(sub) {
            this.sub = sub;
        },
        backhome() {
            this.$router.push('/home');
        },
    },
};
</script>
<style lang="less" scoped>
  // 公共
  .navtab {
      width: 1280px;
      margin: 0 auto;
  }
  .color {
      color: #2961EF !important;
  }
  .ignore {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
  }
  // 搜索
  .nav {
      background: #f7f8fa;
      width: 100%;
      height: 177px;
      .top {
          display: block;
          font-size: 16px;
  
          font-weight: 300;
          color: #777777;
          padding: 19px 0 24px;
          .infor {
              color: #2961EF;
          }
      }
      .newbox {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .newtop {
              font-size: 26px;
              color: #000000;
              margin-bottom: 5px;
          }
          .newbot {
              font-size: 16px;
              color: #888888;
          }
          .input {
              width: 497px;
              height: 59px;
              background: #ffffff;
              box-shadow: 3px 3px 10px 1px rgba(11, 19, 72, 0.050980392156862744);
              border-radius: 30px;
              position: relative;
              input {
                  border: none;
                  position: absolute;
                  left: 30px;
                  top: 0;
                  height: 59px;
                  line-height: 59px;
                  width: 365px;
                  font-size: 16px;
  
                  font-weight: 300;
                  color: #777777;
              }
              .select {
                  position: absolute;
                  right: 12px;
                  top: 8px;
                  width: 74px;
                  height: 43px;
                  line-height: 43px;
                  background: #2961EF;
                  border-radius: 30px;
                  font-size: 16px;
  
                  font-weight: 300;
                  color: #ffffff;
                  text-align: center;
              }
          }
      }
  }
  // 报名信息
  .infor {
      margin-bottom: 70px;
      .title {
          text-align: center;
          font-size: 30px;
          color: #333333;
          margin: 57px 0 50px;
      }
      .infomession {
          border: 20px solid #f7f8fa;
          // padding: 30px;
          .info-inner {
              padding: 40px 71px 85px;
          }
          .subbox {
              float: right;
              margin-top: 40px;
              .close {
                  border: 1px solid #f7f8fa;
                  font-size: 14px;
                  padding: 5px 10px;
                  color: #333333;
                  margin-right: 10px;
                  display: inline-block;
                  cursor: pointer;
                  margin-bottom: 50px;
              }
              .submit {
                  display: inline-block;
                  border: 1px solid #f7f8fa;
                  font-size: 14px;
                  padding: 5px 10px;
                  color: #ffffff;
                  background: #2961EF;
                  cursor: pointer;
                  margin-bottom: 50px;
              }
          }
      }
  }
  // 提交成功
  .success {
      padding: 102px 0;
      .suc {
          text-align: center;
          font-size: 30px;
          font-weight: 600;
          color: #333333;
      }
      img {
          display: block;
          width: 112px;
          height: 112px;
          border-radius: 50%;
          margin: 66px auto;
      }
      .title {
          width: 472px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          background: #f7f8fa;
          border-radius: 5px 5px 5px 5px;
          font-size: 16px;
          color: #333333;
          margin: 0 auto;
          span {
              color: #2961EF;
          }
      }
      // 失败
      .cause {
          font {
              color: red;
          }
          margin: 0 auto 20px;
          width: 803px;
          font-size: 16px;
          color: #656565;
      }
  }
  
 .message {
        padding: 30px 47px;
        background: #f7f8fa;
        .name {
            font-size: 16px;
            color: #333333;
        }
        input {
            background: #ffffff;
            border: none;
            width: 100%;
            margin: 20px 0;
        }
        .input {
            height: 45px;
        }
        .input1 {
            height: 178px;
        }
        .submit {
            width: 234px;
            height: 45px;
            line-height: 45px;
            text-align: center;
            background: #2961EF;
            border-radius: 23px 23px 23px 23px;
            font-size: 20px;
            color: #ffffff;
            margin: 0 auto;
            margin-top: 20px;
        }
		
}
</style>